<template>
  <Field class="form-field" :width="width">
    <label v-if="label" class="form-label" :for="id">
      {{ label }}
    </label>
    <Select
      v-bind="$attrs"
      :class="{ error }"
      :id="id"
    >
      <slot name="default" />
    </Select>
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </Field>
</template>

<script>
import Field from 'Web/Form/Fields/Field.vue';
import Select from 'Web/Form/Inputs/Select.vue';
import uid from '@/helpers/uid';

export default {
  inheritAttrs: false,
  components: {
    Field,
    Select,
  },
  props: {
    error: String,
    id: {
      type: String,
      default: uid,
    },
    label: String,
    width: String,
  },
  setup: Select.setup
}
</script>
